/**
 * Vuex-модуль (хранилище) для работы модального окна активации
 *  двухфакторной аутентификации
 */

const state = {
    // Состояние отображения модального окна подтверждения пароля
    show: false,
    twoFactorAuth: {
        enabled: false,
        secret: null,
        qrCodeUrl: null,
    },
};

const actions = {
    // Отображение модального окна
    showModal: ({ commit }) => commit('showModal'),
    // Скрытие модального окна
    hideModal: ({ commit }) => commit('hideModal'),
    // Активация 2fa
    enable: ({ commit }) => commit('setEnabled', true),
    // Деактивация 2fa
    disable: ({ commit }) => commit('setEnabled', false),
};

const mutations = {
    showModal: state => {
        state.show = true;
    },
    hideModal: state => {
        state.show = false;
    },
    setEnabled: (state, isEnabled) => {
        state.twoFactorAuth.enabled = isEnabled;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
